import { Button,Result } from "../../../../../../shared/frontend/ui";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../../app/i18n/useI18n";

export function ForbiddenPage() {
  const nav = useNavigate();
  const { text } = useI18n();
  return (
    <Result
      status="403"
      title={text("Access denied")}
      subTitle={text("You are not allowed to open this page.")}
      extra={<Button onClick={() => nav("/overview")}>{text("Navigation.backToOverview")}</Button>}
    />
  );
}



